import { all } from 'redux-saga/effects';
import { authSagas } from '../../authContext/usecases/Auth.sagas';
import { applicationSagas } from '../../common/usecases/application/application.sagas';
import { navigationSagas } from '../../navigationContext/usecases/navigation.sagas';
import { generalSagas } from '../../generalContext/usecases/General.sagas';

export function* sagas() {
  yield all([generalSagas(), navigationSagas(), authSagas(), applicationSagas()]);
}
